export const EndPoints = {
  getAllPlans: `/api/v1/vendor/plans/available`,
  getMyPlans: `/api/v1/vendor/plans/my-plan`,
  createPlanOrder: `/api/v1/vendor/plans/create-order`,
  verifyPayment: `/api/v1/vendor/plans/verify-payment`,
};